export const SET_FORMAT = (state, value) => {
  state.format = value
}

export const SET_CREATED = (state, value) => {
  state.created = value
}

export const SET_ISSUE = (state, value) => {
  state.issue = value
}

export const SET_INCOMEDATE = (state, value) => {
  state.incomeDate = value
}

export const SET_PERIOD_START = (state, value) => {
  state.billPeriod.start = value
}

export const SET_PERIOD_END = (state, value) => {
  state.billPeriod.end = value
}

export const SET_ID = (state, value) => {
  state.id = value
}

export const SET_ID_SERIE = (state, value) => {
  state.invoiceId.serie = value
}

export const SET_ID_NUMBER = (state, value) => {
  state.invoiceId.number = value
}

export const SET_PROCEDURE_NUMBER = (state, value) => {
  state.paidRectified.number = value
}

export const SET_PROCEDURE_REASON = (state, value) => {
  state.paidRectified.reason = value
}

export const SET_CONCEPT = (state, value) => {
  state.concept = value
}

export const SET_CUSTOMERASCLIENT = (state, value) => {
  state.customerAsClient = value
}

export const SET_FUND_PROVISION = (state, value) => {
  state.fundProvision = value
}

export const SET_USER_ROLE = (state, value) => {
  state.me = value
}
export const SET_RECTIFIED_SERIE = (state, value) => {
  state.paidRectified.serie = value
}

export const SET_RECTIFIED_NUMBER = (state, value) => {
  state.paidRectified.number = value
}

export const SET_RECTIFIED_REASON = (state, value) => {
  state.paidRectified.reason = value
}

export const SET_RECTIFIED_DESCRIPTION = (state, value) => {
  state.paidRectified.description = value
}

export const SET_EDITING = (state, value) => {
  state.editing = value
}

export const SET_LOADED = (state, value) => {
  state.loaded = value
}

export const SET_TO_RECTIFY = (state, value) => {
  state.toRectify = value
}

export const SET_PARENT_ID = (state, value) => {
  state.paidRectified.rectifiedId = value
}
export const SET_STATUS = (state, value) => {
  state.status = value
}

export const SET_LOCATORCODE = (state, value) => {
  state.locatorCode = value
}

export const SET_INVOICETYPE = (state, value) => {
  state._invoiceType = value
}

export const SET_TO_DUPLICATE = (state, value) => {
  state.toDuplicate = value
}

export const SET_DOBILLPERIOD = (state, value) => {
  state.doBillPeriod = value
}

export const SET_TYPE = (state, value) => {
  state.paidRectified.rectifiedId = undefined
  state.paidRectified.serie = undefined
  state.paidRectified.number = undefined
  state.paidRectified.reason = '1'
  state.paidRectified.description = undefined
  state.type = value
}

export const SET_ONLYSUPPLIED = (state, value) => {
  state.onlySupplied = value
}

export const SET_CHECKINMOBILIZED = (state, value) => {
  state.checkInmobilized = value
}

export const SET_SHOWINVOICEASSETS = (state, value) => {
  state.showInvoiceAssets = value
}

export const SET_SUPPLIEDTOEDIT = (state, value) => {
  state.suppliedToEdit = value
}

export const SET_DOBILLID = (state, value) => {
  state.doBillId = value
}

export const SET_FICHA_TERCEROS = (state, value) => {
  state.fichaTerceros = { ...state.fichaTerceros, ...value }
}
